export const getDigitalPackages = [
  {
    locationId: 1,
    location: "Mumbai",
    options: [
      { id: 101, duration: "1 year", price: 3540, withoutgst: 3000 },
      { id: 102, duration: "2 year", price: 6490, withoutgst: 5500 },
    ],
    canSubscribe: true,
    isRenewable: false,
  },
  {
    locationId: 2,
    location: "Gujarat",
    options: [
      { id: 201, duration: "1 year", price: 2500, withoutgst: 2119 },
      { id: 202, duration: "2 year", price: 3500, withoutgst: 2966 },
    ],
    canSubscribe: true,
    isRenewable: false,
  },
  {
    locationId: 3,
    location: "Chennai",
    options: [
      { id: 301, duration: "1 year", price: 2950, withoutgst: 2500 },
      { id: 302, duration: "2 year", price: 4720, withoutgst: 4000 },
    ],
    canSubscribe: true,
    isRenewable: false,
  },
  {
    locationId: 4,
    location: "Delhi / NCR",
    options: [
      { id: 401, duration: "1 year", price: 2950, withoutgst: 2500 },
      { id: 402, duration: "2 year", price: 4720, withoutgst: 4000 },
    ],
    canSubscribe: true,
    isRenewable: false,
  },
  {
    locationId: 5,
    location: "Kolkata",
    options: [
      { id: 501, duration: "1 year", price: 1475, withoutgst: 1250 },
      { id: 502, duration: "2 year", price: 2950, withoutgst: 2500 },
    ],
    canSubscribe: true,
    isRenewable: false,
  },
  {
    locationId: 6,
    location: "Tuticorin",
    options: [
      { id: 601, duration: "1 year", price: 1180, withoutgst: 1000 },
      { id: 602, duration: "2 year", price: 2360, withoutgst: 2000 },
    ],
    canSubscribe: true,
    isRenewable: false,
  },
  {
    locationId: 7,
    location: "Kochi",
    options: [
      { id: 701, duration: "1 year", price: 1180, withoutgst: 1000 },
      { id: 702, duration: "2 year", price: 2360, withoutgst: 2000 },
    ],
    canSubscribe: true,
    isRenewable: false,
  },
];
